import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { truncate } from 'lodash'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { useArchiveProcess } from 'modules/processes/hooks/useArchiveProcess'
import { useProcess } from 'modules/processes/hooks/useProcess'

type Props = {
  processId: string
  onSuccess: () => void
  onClose: () => void
}

const DeleteProcessModal = observer(({ processId, onSuccess, onClose }: Props) => {
  const { process } = useProcess(processId)
  const { archiveProcess } = useArchiveProcess()

  const { performAction, running: archivingProcess } = useAsyncAction(
    async () => {
      await archiveProcess(processId)

      onSuccess()
    },
    { successMessage: i18n.t('processes.delete_process.success_in_progess') }
  )

  const truncatedName = truncate(process?.name, { length: 40 })

  return (
    <Modal
      illustration="alert"
      title={
        (process &&
          i18n.t('processes.delete_process.title', {
            name: truncatedName,
          })) ??
        ''
      }
      description={
        (process &&
          i18n.t('processes.delete_process.description', {
            name: truncatedName,
          })) ??
        ''
      }
      onSubmit={performAction}
      onClose={onClose}
      locked={archivingProcess}
      footer={
        <>
          <Button disabled={archivingProcess} type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={archivingProcess} submit>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    ></Modal>
  )
})

const DeleteProcessModalPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(-1)
  }

  if (!id) {
    onClose()
    return null
  }

  return <DeleteProcessModal processId={String(id)} onClose={onClose} onSuccess={onClose} />
}

export default DeleteProcessModalPage
